import fb from "../firebase";
import firebase from "firebase/compat/app";
import {UseFirestoreOptions, useFirestoreSnap} from "./useFirestore";

export const useLojasSnap = (args: {userId: string}, options?: UseFirestoreOptions): [firebase.firestore.QuerySnapshot|undefined, boolean] => {
  const {userId} = args;

  return useFirestoreSnap({
    queryKey: `useLojasSnap:${userId}`,
    query: () => fb.db.collection('lojas')
      .where('owner', '==', userId)
      .orderBy('nome', 'asc'),
    options,
  });
}